import * as React from "react";
import { SVGProps } from "react";
export function BriefCaseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={17}
      height={17}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#brief-case_svg__a)"
        stroke="#535455"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 5.5H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1ZM2 9.5h13M8.5 8.5v2M11.5 5.5a3 3 0 0 0-6 0" />
      </g>
      <defs>
        <clipPath id="brief-case_svg__a">
          <path fill="#fff" transform="translate(1.5 1)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
